// extracted by mini-css-extract-plugin
module.exports = {"sectionIntroduction":"SectionIntroduction_sectionIntroduction_yCmOH"};